<template>
  <a-modal
    v-model:visible="serviceAttributionVisible"
    wrapClassName="serviceAttributionModal"
    width="80%"
    :bodyStyle="{
      padding: '0px',
      height: '80vh'
    }"
    :footer="null"
    destroyOnClose
    maskClosable
  >
    <template #title>
      <Breadcrumb ref="breadcrumbRef" @updateView="handleUpdateView" />
    </template>
    <!-- 动态渲染子组件 -->
    <component
      :is="currentComponent"
      v-bind="currentProps"
      :key="componentKey"
      @pushBreadcrumb="handlePushBreadcrumb"
    />
  </a-modal>
</template>
<script setup>
import { ref, defineExpose, defineProps, nextTick, markRaw } from 'vue'
import Breadcrumb from './components/Breadcrumb'
import MyService from './MyService'
const serviceAttributionVisible = ref(false)
const breadcrumbRef = ref('')
// 当前显示的组件
const currentComponent = ref(null)
// 当前显示的组件所需参数
const currentProps = ref({})
const componentKey = ref(0)
const props = defineProps({
  // 当前医生信息
  data: {
    type: Object,
    default: () => {}
  }
})
// 当面包屑栈变化时更新动态组件
const handleUpdateView = ({ component, props, key }) => {
  currentComponent.value = component
  currentProps.value = props
  componentKey.value = key
}
// 动态组件触发事件新增层级
const handlePushBreadcrumb = ({ htmlTitle, title, component, props }) => {
  breadcrumbRef.value.pushStack({
    htmlTitle,
    title,
    component,
    props
  })
}
// 打开服务归属弹窗
const showModal = () => {
  const { data } = props
  serviceAttributionVisible.value = true
  nextTick(() => {
    breadcrumbRef.value.pushStack({
      htmlTitle: `医生服务 <span class="breadcrumb-username">（${data.username}医生）</span>`,
      component: markRaw(MyService),
      props: { ucDoctorId: data.ucUserId, userId: data.businessId }
    })
  })
}
defineExpose({
  showModal
})
</script>
<style lang="scss"></style>
